import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import CustomPreLoader from "./../../utils/CustomPreLoader/CustomPreLoader";
import PublicContainer from "../PublicContainer/PublicContainer";
import NotFoundPage from "./../../components/Page/NotFoundPage/NotFoundPage";
import AdminContainer from "../AdminContainer/AdminContainer";
import AuthContainer from "../AuthContainer/AuthContainer";
import OrganContainer from "../OrganContainer/OrganContainer";
import NotificationListener from "../../utils/NotificationListener/NotificationListener";
import {
  baseAdminURL,
  baseOrganURL,
  handleCheckPersianNumberInput,
} from "../../utils";

const App = () => {
  const isLoader = useSelector((state) => state.isLoader);

  useEffect(() => {
    document.addEventListener("input", handleCheckPersianNumberInput, {
      capture: true,
    });
    return () => {
      document.removeEventListener("input", handleCheckPersianNumberInput, {
        capture: true,
      });
    };
  }, []);

  return (
    <>
      {isLoader && <CustomPreLoader />}

      <ToastContainer
        position="bottom-right"
        stacked
      />
      <NotificationListener />
      <Routes>
        <Route path={baseAdminURL + "/*"} element={<AdminRoutes />} />
        <Route path={baseOrganURL + "/*"} element={<OrganRoutes />} />
        {/* Public Container */}
        <Route path="/*" element={<PublicContainer />} />
        {/* Not Found Component */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Admin Container */}
      <Route path="/Admin/*" element={<AdminContainer />} />
      {/* Public Container */}
      <Route path="/Auth/*" element={<AuthContainer />} />
      {/* Public Container */}
      <Route path="/*" element={<PublicContainer />} />
      {/* Not Found Component */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

const OrganRoutes = () => {
  return (
    <Routes>
      {/* Organ Container */}
      <Route path="/Organ/*" element={<OrganContainer />} />
      {/* Public Container */}
      <Route path="/Auth/*" element={<AuthContainer isOrgan />} />
      {/* Public Container */}
      <Route path="/*" element={<PublicContainer isOrgan />} />
      {/* Not Found Component */}
      <Route path="*" element={<NotFoundPage isOrgan />} />
    </Routes>
  );
};
